import request from '@/utils/request'

const urlPrefix = '/source-busyness'

export function getSourceBusynessItemList (params) {
  return request.get(`${urlPrefix}/items`, { params })
}

export function getSourceBusynessIndicator (id) {
  return request.get(`${urlPrefix}/indicators/${id}`)
}

export function createSourceBusynessIndicator (data) {
  return request.post(`${urlPrefix}/indicators`, data)
}

export function getSourceBusynessIndicatorList (params) {
  return request.get(`${urlPrefix}/indicators`, { params })
}

export function updateSourceBusynessIndicator (id, data) {
  return request.put(`${urlPrefix}/indicators/${id}`, data)
}

export function deleteSourceBusynessIndicator (id) {
  return request.delete(`${urlPrefix}/indicators/${id}`)
}
